import {MenuItem} from '@material-ui/core';
import React, {useContext, useState} from 'react';
import CorrectionInvoiceDialog from '../dialogs/CorrectionInvoiceDialog';
import {AlertContext} from '../../../components/contexts/WithAlertContext';
import {InvoiceListDataContext} from '../InvoiceListDataContextProvider';
import {useTranslation} from 'react-i18next';
import {InvoiceActionType} from './InvoiceActionHelper';
import InvoiceService from '../../../services/InvoiceService';
import ReloadContext from '../../../components/contexts/ReloadContext';

const InvoiceCorrectionAction = React.forwardRef(({ invoice, closeMenu, label }: InvoiceActionType, ref: React.Ref<any>) => {
  const [showCorrection, setShowCorrection] = useState(false);
  const [correctionInvoiceId, setCorrectionInvoiceId] = useState<string>();
  const [invoicePdf, setInvoicePdf] = useState<{ name: string; content: any }>();
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation(['debitors', 'invoices']);
  const alerting = useContext(AlertContext);
  const invoiceReload = useContext(InvoiceListDataContext)?.reload;
  const contextReload = useContext(ReloadContext)?.reload;
  const reload = () => {
    invoiceReload();
    contextReload();
  };

  const correctInvoice = (reasons: any) => {
    InvoiceService.createCorrectiveInvoice(invoice.id, reasons)
      .then(({ id }) => {
        setCorrectionInvoiceId(id);
        InvoiceService.previewCancelInvoice(id).then((invoicePdfDoc) => {
          setInvoicePdf(invoicePdfDoc);
        });
      })
      .catch(() => {
        alerting.sendAlert('error', t('correction unsuccessfull'));
      });
  };

  const finalizeInvoiceCorrection = () => {
    setLoading(true);
    InvoiceService.finalizeInvoiceCorrection(correctionInvoiceId ? correctionInvoiceId : invoice.id).then((res) => {
      if (res) {
        setLoading(false);
        alerting.sendAlert('success', t('successfully sent'));
        reload();
      } else {
        alerting.sendAlert('error', t('unsuccessfully sent'));
        reload();
      }
      setShowCorrection(false);
      setInvoicePdf(undefined);
    });
  };

  return (
    <div key={invoice.id + 'correctionC'} ref={ref}>
      <MenuItem
        key={invoice.id + 'correction'}
        onClick={() => {
          closeMenu();
          setShowCorrection(true);
        }}
      >
        {label}
      </MenuItem>

      {showCorrection && (
        <CorrectionInvoiceDialog
          key={invoice.id + 'correct'}
          onCancel={() => {
            setShowCorrection(false);
            setCorrectionInvoiceId(undefined);
            reload();
          }}
          onCorrect={correctInvoice}
          onFinalize={finalizeInvoiceCorrection}
          invoicePdf={invoicePdf}
          loading={loading}
          open={true}
        />
      )}
    </div>
  );
});

export default InvoiceCorrectionAction;
